import { Icon } from './chunk-VH4ICUUK.js';
import { tv } from './chunk-7NOFBOMW.js';
import { cn } from './chunk-UYYBXMNI.js';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

var checkboxStyles = tv({
  slots: {
    root: [
      "border-primary data-[state=checked]:bg-primary data-[state=indeterminate]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:text-primary-foreground hover:bg-accent peer h-4 w-4 shrink-0 rounded border shadow disabled:cursor-not-allowed disabled:opacity-50",
      "focus-visible:ring-ring focus:ring-offset-2 focus-visible:outline-none focus-visible:ring-2"
    ],
    indicator: "flex items-center justify-center rounded text-current"
  },
  variants: {
    invalid: {
      true: {
        root: "border-destructive"
      }
    }
  }
});
var Checkbox = forwardRef(
  ({ className, classNames, invalid, ...props }, ref) => {
    const slots = checkboxStyles();
    const rootClasses = cn(classNames?.root, className);
    const indicatorClasses = classNames?.indicator;
    return /* @__PURE__ */ jsx(
      CheckboxPrimitive.Root,
      {
        "aria-invalid": invalid,
        "aria-disabled": props.disabled,
        ref,
        className: slots.root({ class: rootClasses, invalid }),
        ...props,
        children: /* @__PURE__ */ jsx(CheckboxPrimitive.Indicator, { className: slots.indicator({ class: indicatorClasses }), children: props.checked === "indeterminate" ? /* @__PURE__ */ jsx(Icon, { name: "minus", className: "h-4 w-4" }) : /* @__PURE__ */ jsx(Icon, { name: "check", className: "h-4 w-4" }) })
      }
    );
  }
);

export { Checkbox, checkboxStyles };
//# sourceMappingURL=chunk-I7CVMEPF.js.map
//# sourceMappingURL=chunk-I7CVMEPF.js.map